import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
  SummaryGrid,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
} from "./MonthlyReport.styles";
import { AccountBalance, Business } from "@mui/icons-material";
import { formatNumber, isPositiveAmount } from "./MonthlyReport.utils";
import MonthlyReportSummary from "./MonthlyReport.summary";
import MonthlyReportFeesBreakdown from "./MonthlyReport.feesBreakdown";
import MonthlyReportCommissionConfig from "./MonthlyReport.commissionConfig";
import MonthlyReportISOAccordion from "./MonthlyReport.isoAccordion";
import MonthlyReportMerchantsTable from "./MonthlyReport.merchantsTable";

const MonthlyReportAdmin = ({ reportData }) => {
  const { summary, acquirers } = reportData;

  return (
    <GridContainer spacing={0}>
      <MonthlyReportSummary summary={summary} />
      <MonthlyReportFeesBreakdown summary={summary} />
      
      {/* Acquirers */}
      {acquirers && acquirers.length > 0 && (
        <GridItem xs={12} padding="0 0 15px 0">
          <DataCard>
            <DataCardHeader>
              <AccountBalance color="primary" />
              <DataCardTitle>Acquirers</DataCardTitle>
            </DataCardHeader>
            {acquirers.map((acquirer, acquirerIndex) => (
              <Accordion key={acquirerIndex}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <GridContainer spacing={0} alignItems="center">
                    <GridItem xs={12} sm={6}>
                      <Typography variant="h6">
                        {acquirer.acquirerName || acquirer.acquirerID}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Acquirer ID: {acquirer.acquirerID}
                      </Typography>
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <Typography variant="body2" color="text.secondary">
                        Net Residual
                      </Typography>
                      <SummaryValue positive={isPositiveAmount(acquirer.summary?.total_fees)}>
                        ${formatNumber(acquirer.summary?.total_fees)}
                      </SummaryValue>
                    </GridItem>
                  </GridContainer>
                </AccordionSummary>
                <AccordionDetails>
                  <GridContainer spacing={0}>
                    {/* Acquirer Summary */}
                    <GridItem xs={12} padding="0 0 15px 0">
                      <DataCard>
                        <DataCardHeader>
                          <Business color="primary" />
                          <DataCardTitle>Acquirer Summary</DataCardTitle>
                        </DataCardHeader>
                        <SummaryGrid spacing={0} style={{ marginTop: "16px" }}>
                          <GridItem xs={12} sm={6}>
                            <SummaryItem>
                              <SummaryLabel>Amount</SummaryLabel>
                              <SummaryValue>
                                ${formatNumber(acquirer.summary?.total_transaction_amount)}
                              </SummaryValue>
                            </SummaryItem>
                          </GridItem>
                          <GridItem xs={12} sm={6}>
                            <SummaryItem>
                              <SummaryLabel>Transactions</SummaryLabel>
                              <SummaryValue>{acquirer.summary?.total_transaction_count || 0}</SummaryValue>
                            </SummaryItem>
                          </GridItem>
                        </SummaryGrid>
                      </DataCard>
                    </GridItem>

                    {/* Commission Config */}
                    <MonthlyReportCommissionConfig
                      commission_config={acquirer.commission_config}
                      userType="acquirer"
                    />

                    {/* Direct Merchants */}
                    {acquirer.direct_merchants && acquirer.direct_merchants.length > 0 && (
                      <MonthlyReportMerchantsTable
                        merchants={acquirer.direct_merchants}
                        title="Direct Merchants"
                      />
                    )}

                    {/* ISOs */}
                    <MonthlyReportISOAccordion isos={acquirer.isos} />
                  </GridContainer>
                </AccordionDetails>
              </Accordion>
            ))}
          </DataCard>
        </GridItem>
      )}
    </GridContainer>
  );
};

export default MonthlyReportAdmin;

